export const svgToUrl = (svgString: string | undefined): string => {
	if (!svgString) return ""
	const minified = svgString.replace(/>\s+</g, "><").replace(/\s{2,}/g, " ")
	const base64 = btoa(minified)
	return `data:image/svg+xml;base64,${base64}`
}
